import { sql } from "@-/com.npmjs.drizzle-orm";
import { toneNumbersPinyinText } from "@-/dev.improve.haniverse.database.schemas._lib.types.pinyin";
import { staticTable } from "@-/dev.improve.haniverse.database.schemas.static._lib.table";
import { bool, index as dbIndex, integer, text } from "@-/dev.improve.haniverse.lib.database.table";
import { graphemeTable } from "@-/dev.improve.haniverse.database.schemas.static.schema._tables.grapheme";

/** A grapheme has many definitions */
export const graphemeDefinitionTable = staticTable(
  "grapheme_definition",
  {
    graphemeId: integer("grapheme_id")
      .notNull()
      .references(() => graphemeTable.id),

    /** English definition */
    definition: text("definition").notNull(),

    /** Pinyin for this definition */
    pinyin: toneNumbersPinyinText("pinyin").notNull(),

    /** Position of this definition within its source entry (0-based). */
    index: integer("index").notNull(),

    /** Whether this definition is applicable within Mainland China (PRC). */
    prcApplicable: bool("prc_applicable").notNull(),

    /** Whether this definition is applicable within Taiwan. */
    twApplicable: bool("tw_applicable").notNull(),

    /** Whether this definition is applicable within Hong Kong. */
    hkApplicable: bool("hk_applicable").notNull(),
  },
  (table) => [
    dbIndex("grapheme_definition_grapheme_id_idx").on(table.graphemeId),
    // SQLite LIKE is case-insensitive, so prefix searches require a NOCASE index.
    dbIndex("grapheme_definition_pinyin_nocase_idx").on(sql`${table.pinyin} COLLATE NOCASE`),
  ],
);

export type GraphemeDefinition = typeof graphemeDefinitionTable.$inferSelect;
